interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  accent?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'left',
  accent = false,
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-6 md:mb-8 ${align === 'center' ? 'flex flex-col items-center text-center' : ''}`}
    >
      <div
        className={`inline-flex items-center gap-2 ${align === 'center' ? 'justify-center' : ''}`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-primary-500 inline-block"></span>
        <span className="font-label text-xs md:text-sm font-medium tracking-widest text-primary-600 uppercase">
          {eyebrow}
        </span>
        <span className="w-1.5 h-1.5 rounded-full bg-accent-500 inline-block"></span>
      </div>
      <h2
        className={`mt-2 text-2xl md:text-4xl font-heading font-bold text-foreground-950 ${
          accent ? 'text-background-50' : ''
        }`}
      >
        {title}
      </h2>
      {desc ? (
        <p
          className={`mt-3 text-sm md:text-base leading-relaxed max-w-2xl ${
            accent ? 'text-background-100/80' : 'text-foreground-600'
          }`}
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}